document.addEventListener('DOMContentLoaded', () => {

  const triggers = document.querySelectorAll('[data-flyover-trigger]')
  const flyoverBackdrop = document.querySelector('[data-flyover-backdrop]')
  const flyoverCloseBtns = document.querySelectorAll('[data-flyover-close]')
  const pdpFlyovers = document.querySelectorAll('[data-pdp-flyover]')
  
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      const targetId = trigger.dataset.target
      
      if (pdpFlyovers.length > 0) {
        pdpFlyovers.forEach(pdpFlyoverEl => {
          pdpFlyoverEl.classList.toggle('active')
          flyoverBackdrop && flyoverBackdrop.classList.add('active')
          document.body.classList.add('lock')

          // Find and click the corresponding inner trigger
          const matchingInnerTrigger = pdpFlyoverEl.querySelector(`[data-flyover-inner-trigger][data-target-content="${targetId}"]`)
          if (matchingInnerTrigger) {
            matchingInnerTrigger.click()
          }
        })
      }
    })
  })

  function closeFlyover(event) {
    event.preventDefault()
    event.stopPropagation()
    document.body.classList.remove('lock')
    flyoverBackdrop && flyoverBackdrop.classList.remove('active')
    pdpFlyovers.forEach(flyover => {
      flyover.classList.remove('active')
    })
  }

  flyoverBackdrop && flyoverBackdrop.addEventListener('click', (event) => {
    closeFlyover(event)
  })
  
  flyoverCloseBtns.forEach(closeBtn => {
    closeBtn.addEventListener('click', (event) => {
      closeFlyover(event)
    })
  })

  const innerTriggers = document.querySelectorAll('[data-flyover-inner-trigger]')
  if (innerTriggers.length > 0) {
    innerTriggers.forEach(innerTrigger => {
      innerTrigger.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        innerTriggers.forEach(t => {
          t.classList.remove('active')
          const pGroup = t.closest('.flyover-inner-group')
          pGroup.classList.remove('active')
        })

        innerTrigger.classList.add('active')
        const parentGroup = event.currentTarget.closest('.flyover-inner-group')
        parentGroup.classList.add('active')
      })
    })
  }

})